import { Auth } from '@aws-amplify/auth';

import { useAuthContext } from 'lib/core/context/AuthProvider';

export default function useIsolatedNavigate() {
  const { user } = useAuthContext();

  return async (link: string = window.location.pathname) => {
    const token = (await Auth.currentSession()).getAccessToken().getJwtToken();

    const isolatedUrlParams = `?standalone=true&user=${user?.connectInformation.connectUsername}&token=${token}`;

    window.open(`${window.location.origin}${link}${isolatedUrlParams}`, '_blank');
  };
}
